import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { formatAnnotationStyleSize, StyleSize, textAnnotationFontSizes } from "./AnnotationSettings";

import styles from "./TextAnnotationSettings.module.scss";

interface TextAnnotationSettingsProps {
    /** On text settings selection. */
    onChange: (styles: Record<string, string>) => void;

    /** Display text settings */
    isVisible: boolean;
}

/** A React component that display settings for text annotation tools. */
function TextAnnotationSettings(props: TextAnnotationSettingsProps): JSX.Element {
    const { getText } = useTranslation();
    const [fontSize, setFontSize] = useState<StyleSize>(textAnnotationFontSizes.firstOrDefault(p => p.isDefault));

    function changeFontSize(value: StyleSize): void {
        setFontSize(value);
        props.onChange({ FontSize: formatAnnotationStyleSize(value) });
    }

    return (
        <div className={`${styles.textAnnotationSettings} ${!props.isVisible ? "hidden" : ""}`}>
            <label>{getText("SizeLabel")}</label>
            <select
                className="form-control myle-control"
                onChange={e => changeFontSize(textAnnotationFontSizes.firstOrDefault(p => p.value === Number(e.target.value)))}
                value={fontSize.value}
            >
                {textAnnotationFontSizes.map(size => (
                    <option key={size.value} value={size.value}>
                        {size.value}
                    </option>
                ))}
            </select>
        </div>
    );
}

export { TextAnnotationSettings };
